import { useEffect } from "react";
import initializePrintingAllowed from 'meta/extensions/printing-allowed/printing-allowed';
export const usePrintingAllowed = () => {
    useEffect(() => {
        initializePrintingAllowed();
    }, []);
};
